import './index.styl';
import template from './index.jst';
import TeamControls from '../../Fantasy/Controls';

export class TeamInfo extends TeamControls {
	get className() {
		return 'team-builder-info';
	}

	get template() {
		return template;
	}

	fetchData() {
		let {
			round_points,
			user_id,
			rank,
			overall_rank,
			overall_points
		} = this.options;

		this.model.set({
			round_points,
			rank,
			overall_rank,
			overall_points
		}).fetch({
			data: {
				user_id
			}
		});
	}

	init(args) {
		this.model.set(args);
		return this;
	}
}

export default TeamInfo;